import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    '& .ant-card-head': {
      minHeight: 'auto',
      padding: 0,
      backgroundColor: '#fff',
      borderBottom: 'none',
    },

    '& .ant-card-body': {
      padding: 0,
    },

    '& .ant-card-head-title': {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 600,
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  tableCard: {
    marginTop: 24,
    paddingBottom: 24,
    borderBottom: '1px solid rgba(0, 0, 0, 0.09)',

    '& .ant-card-head': {
      borderBottom: 'none',
      minHeight: 'auto',
      marginBottom: 4,
    },

    '& .ant-card-extra': {
      padding: 0,
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 600,
      color: '#38B2A6',
      '&:hover': {
        cursor: 'pointer',
      },
    },

    '& .ant-card-head-title': {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 400,
      paddingTop: 0,
    },

    '& .ant-card-body': {},
  },
  tableCardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& .ant-col': {
      fontSize: 14,
      lineHeight: '22px',
      color: 'rgba(0, 0, 0, 0.45)',
    },

    '&:not(:last-child)': {
      marginBottom: 8,
    },

    '& .ant-col:nth-child(1)': {
      width: 20,
      textAlign: 'left',
      marginRight: 8,
    },
    '& .ant-col:nth-child(2)': {
      width: 'calc(67% - 28px)',
      paddingRight: 64,

      '& a': {
        display: 'inline-block',
        maxWidth: '100%',
        fontSize: 14,
        lineHeight: '24px',
        color: theme.colors.bodyColor,
        verticalAlign: 'top',
        ...theme.singleLineOverflow,

        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
    '& .ant-col:nth-child(3)': {
      width: '33%',

      '& span': {
        display: 'inline-block',
        maxWidth: '100%',
        lineHeight: '24px',
        verticalAlign: 'top',
        ...theme.singleLineOverflow,
      },
    },
  },
  emptyRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& .ant-btn': {
      paddingLeft: 8,

      '& .anticon + span, & span + .anticon': {
        marginLeft: 4,
      },
    },
  },
  emptyRowText: {
    color: 'rgba(0, 0, 0, .25)',
  },
  emptyNote: {
    color: theme.colors.disableColor,
  },

  // Modal
  cardHeader: {
    height: '48px',
    lineHeight: '48px',
    paddingLeft: '43px',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: theme.colors.gray2,

    '& .ant-typography': {
      position: 'relative',
      color: theme.colors.gray8,

      '&::before': {
        content: '""',
        position: 'absolute',
        left: -8,
        top: 3,
        width: 3,
        height: 16,
        backgroundColor: theme.colors.mainGreen6,
      },
    },
  },
  formSection: {
    padding: '16px 32px 20px 24px',
  },
  formHeader: {
    display: 'flex',
    marginBottom: 8,

    '& .ant-typography': {
      fontSize: '14px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, .45)',
    },
  },
  formLeft: {
    width: '20px',
    marginRight: '12px',

    '& .anticon-minus-circle svg': {
      width: 20,
      height: 20,
      cursor: 'pointer',
      fill: theme.colors.gray6,
    },
  },
  formMiddle: {
    flex: 1,

    '& .ant-input-group-addon': {
      color: '#4c4c4c !important',
    },

    '& .ant-input-group-addon:last-child': {
      padding: 0,
    },

    '& .ant-typography': {
      fontSize: 12,

      '&:last-child': {
        fontWeight: 'normal',
        paddingLeft: 4,
      },
    },
  },
  formRight: {
    alignSelf: 'flex-start',
    width: 208,
    marginLeft: 40,

    '& .ant-typography': {
      fontSize: 12,
    },
  },
  formMain: {},
  formInput: {
    display: 'flex',
    alignItems: 'center',

    '&:not(:last-child)': {
      marginBottom: 16,
    },

    '& .ant-legacy-form-item': {
      marginBottom: 0,

      '& .ant-input, & .ant-legacy-form-explain': {
        fontSize: 12,

        '&::placeholder': {
          fontSize: 12,
        },
      },
    },
  },
  emptyText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& .ant-typography': {
      color: '#9E9E9E',
    },

    '& .ant-btn': {
      paddingLeft: 8,

      '& .anticon + span, & span + .anticon': {
        marginLeft: 4,
      },
    },
  },
  addButton: {
    marginLeft: 17,
    marginTop: 6,
  },
  checkButton: ({ disabled }) => ({
    fontSize: 12,
    lineHeight: '22px',
    padding: '4px 15px 4px',
    color: disabled ? theme.colors.gray6 : theme.colors.mainGreen6,
    cursor: disabled ? 'not-allowed' : 'pointer',
    backgroundColor: disabled ? theme.colors.gray3 : theme.colors.gray1,
  }),
}));

export default useStyles;
